// app/src/features/settings/TosPreviewHost.jsx
import React from "react";
import TosGate from "../../TosGate";

/**
 * The "Replay ToS Gate" preview (the Settings debug section's SHOW button): the real `TosGate`
 * UI as a dismissible overlay, rendered beside `AppFrame` (not a frame slot) so the phone and the
 * desktop layouts both get it. No `onAccepted`: preview mode routes ACCEPT and DECLINE through
 * `onPreviewClose`. `ctx.themeRaw` is the raw-hex palette `TosGate` takes as `colors`.
 */
export default function TosPreviewHost({ ctx }) {
  const { tosPreview, setTosPreview, themeRaw } = ctx;
  return tosPreview ? (
    <TosGate tos={tosPreview} onPreviewClose={() => setTosPreview(null)} colors={themeRaw} />
  ) : null;
}
